import { danger } from 'redux-store/reducers/common-reducer';

import { __t, applyTranslations } from 'utils/language';
import { API, destroy, get, patch, post } from 'utils/api';
import { logError } from 'utils/log';
import { generateErrorMsg } from '../utils/campaign-purchase-order';

applyTranslations(require('../campaign-purchase-order.i18n.json'));

import type { Dispatch, ThunkAction } from 'types';
import {
  CampaignPurchaseOrder,
  CampaignPurchaseOrderAction,
  CampaignPurchaseOrderBackendResponse
} from '../types';

const { PAYOUTS } = API.END_POINTS;

const MSG_KEY = 'campaign_purchase_order';

export const fetchAction = (
  data: CampaignPurchaseOrderBackendResponse
): CampaignPurchaseOrderAction => ({
  type: 'purchase-order-fetch',
  payload: {
    data
  }
});

export const addAction = (
  data: CampaignPurchaseOrderBackendResponse
): CampaignPurchaseOrderAction => ({
  type: 'purchase-order-add',
  payload: {
    data
  }
});

export const deleteAction = (): CampaignPurchaseOrderAction => ({
  type: 'purchase-order-delete'
});

export const flushAction = (): CampaignPurchaseOrderAction => ({
  type: 'purchase-order-flush'
});

export const fetchPurchaseOrder = (
  campaignId: number
): ThunkAction => (
  async (dispatch: Dispatch) => {
    try {
      const url = PAYOUTS.handlePurchaseOrder(campaignId);
      const response = await get(url);
      const data: CampaignPurchaseOrderBackendResponse = response?.data ?? null;

      dispatch(fetchAction(data));
    } catch (error) {
      logError(error);
      dispatch(danger(__t(`${MSG_KEY}.errors.service`)));
    }
  }
);

export const addPurchaseOrder = (
  campaignId: number,
  purchaseOrder: CampaignPurchaseOrder
): ThunkAction => (
  async (dispatch: Dispatch) => {
    try {
      const url = PAYOUTS.handlePurchaseOrder(campaignId);

      const requestBody = {
        pon: purchaseOrder.pon.value,
        costCenter: purchaseOrder.costCenter.value
      };

      const response = await post(url, { data: requestBody });
      const data: CampaignPurchaseOrderBackendResponse = response?.data ?? null;

      dispatch(addAction(data));
    } catch (error) {
      const errorMsg = generateErrorMsg(error, campaignId, purchaseOrder.id);

      logError(error);
      dispatch(danger(errorMsg));
    }
  }
);

export const patchPurchaseOrder = (
  campaignId: number,
  purchaseOrder: CampaignPurchaseOrder
): ThunkAction => (
  async (dispatch: Dispatch) => {
    try {
      const url = `${PAYOUTS.handlePurchaseOrder(campaignId)}/${purchaseOrder.id}`;

      const requestBody = {
        pon: purchaseOrder.pon.value,
        costCenter: purchaseOrder.costCenter.value
      };

      const response = await patch(url, { data: requestBody });
      const data: CampaignPurchaseOrderBackendResponse = response?.data ?? null;

      dispatch(addAction(data));
    } catch (error) {
      const errorMsg = generateErrorMsg(error, campaignId, purchaseOrder.id);

      logError(error);
      dispatch(danger(errorMsg));
    }
  }
);

export const deletePurchaseOrder = (
  campaignId: number,
  purchaseOrder: CampaignPurchaseOrder
): ThunkAction => (
  async (dispatch: Dispatch) => {
    try {
      const url = `${PAYOUTS.handlePurchaseOrder(campaignId)}/${purchaseOrder.id}`;

      await destroy(url);

      dispatch(deleteAction());
    } catch (error) {
      const errorMsg = generateErrorMsg(error, campaignId, purchaseOrder.id);

      logError(error);
      dispatch(danger(errorMsg));
    }
  }
);
